import { render, staticRenderFns } from "./storeInfo.vue?vue&type=template&id=951b3bd6&scoped=true&lang=html&"
import script from "./storeInfo.vue?vue&type=script&lang=js&"
export * from "./storeInfo.vue?vue&type=script&lang=js&"
import style0 from "./storeInfo.vue?vue&type=style&index=0&id=951b3bd6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951b3bd6",
  null
  
)

export default component.exports